import UserTracking from './modules/UserTracking'
import Rating from './modules/rating'
import YoutubeVideo from './modules/YoutubeVideo'
import MegaMenu from './modules/MegaMenu'
import 'normalize.css'
import '../css/font.css'
import '../css/font-awesome.min.css'
import '../css/bootstrap.min.css'
import '../css/ion.rangeSlider.css'
import '../css/ion.rangeSlider.skinFlat.css'
import '../css/style.less'

import './modules/lazyload'
import './modules/scroll'
import './sieroty.min.js'
import '../js/code.uncompressed'

import './pages/pozycjonowanie'
import './pages/pozycjonowanie-sklepow-internetowych'
import MobileMegaMenu from './modules/MobileMegaMenu'

new Rating('.opinion__stars')
new YoutubeVideo()
new UserTracking()
new MegaMenu()
new MobileMegaMenu()
